export default __webpack_public_path__ + "static/phone_chatbot-fb42df357e4011ce19f5b7673633e74e.png";